import React from 'react';
import { Modal, HeadingText40 } from '@modernhealth/vital-components';
import { useTranslation } from 'react-i18next';

interface SessionNotFoundModalProps {
    isVisible: boolean;
    onClose: () => void;
}

export const SessionNotFoundModal = ({ isVisible, onClose }: SessionNotFoundModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal isVisible={isVisible} onCloseButtonClick={onClose} maxWidth={558}>
            <HeadingText40>
                {t('pathways:components.session_modal.session_not_found')}
            </HeadingText40>
        </Modal>
    );
};
